import { Injectable } from '@angular/core';
import { DomainType, DomainUrl } from '../common/enums/app-domain.enum';

@Injectable({
    providedIn: 'root'
})
export class DomainManagerService {
    private readonly _domainType: DomainType;
    private readonly hostname: string = window.location.hostname;

    constructor() {
        this._domainType = this.determineDomainType();
    }

    private determineDomainType(): DomainType {
        const host = this.hostname.toLowerCase();

        // Check for specific product keywords in the hostname
        if (host.includes('plusradiology')) {
            return DomainType.Radiology;
        }

        if (host.includes('plusdoctor')) {
            return DomainType.Doctor;
        }

        // Default or Physio
        return DomainType.Physio;
    }

    public get domainType(): DomainType {
        return this._domainType;
    }

    public get isRadiologyDomain(): boolean {
        return this._domainType === DomainType.Radiology;
    }

    public get isDoctorDomain(): boolean {
        return this._domainType === DomainType.Doctor;
    }

    public get isPhysioDomain(): boolean {
        return this._domainType === DomainType.Physio;
    }

    public getLogoUrl(): string {
        switch (this._domainType) {
            case DomainType.Radiology:
                return '/assets/image/Plus-Radiology.png';
            case DomainType.Doctor:
                return '/assets/image/Plus-Doctor-logo.png';
            case DomainType.Physio:
            default:
                return '/assets/image/logo.jpg';
        }
    }

    public get isTestDomain(): boolean {
        return this.hostname.includes(DomainUrl.Localhost) || this.hostname.includes(DomainUrl.IfourConsultancy);
    }
}
